import { CommonSetting, SurveySetting } from './survey';
import { Pages, Group, Matrix } from './pages';
import { CorpSetting } from './corp-setting';
import { SurveyDetail } from './survey-detail';
import { LanguageData } from './language-data';
import { ResponseInfo } from './response-info';
import { SurveyMessages } from './survey-messages';
import { DirectoryLinkedQuestionDetails, DirQuestionPiping } from './directory-linking';
import { ParticipationResponseData, ResponseData } from './response-data';
import { Questions } from './questions';

export class EditResponseData {
  Questions: Questions[];
  Groups: Group[];
  LanguageDatas: LanguageData[];
  CorpSettings: CorpSetting;
  SurveyDetails: SurveyDetail;
  SurveySettings: SurveySetting;
  ResponseInfo: ResponseInfo;
  SurveyMessages: SurveyMessages;
  Matrix: Matrix[];
  directoryLinkedQuestionDetails: DirectoryLinkedQuestionDetails;
  dirQuestionPipings: DirQuestionPiping[];
  participationResponseData :ParticipationResponseData;
  commonSetting:CommonSetting;
  questionRules:QuestionRules[];
  isComplete: boolean;
  responseSrNo:number;
}

export class QuestionRules
{
  QType :string;
  AnsOperator :string;
  ZarcaQId :number;
  ConditionValueText :string;
  ConditionValueID :string;
  ResponseDatas: ResponseData[];
}

export class EditResponseSearchModel
{
    corporateNo:number;
    lang :number;
    surveyId :number;
    surveyNo :number;
    responseUid :number;
    responseNo :number;
    isPostPop:boolean;
    distributionID:number;
    editResponseData:EditResponseData;
    participationResponseData :ParticipationResponseData;
    subMode :string;
}